import { request } from '../client'
import type { ActivityItem } from '@/store/activityFeed'

export interface GetRecentActivityParams {
    limit?: number
}

export async function getRecentActivity(limit = 10) {
    return request<ActivityItem[]>({
        url: '/v1/activity-feed',
        method: 'GET',
        params: { limit },
        skipAuth: true,
    })
}
